import { h, type VNode } from 'snabbdom';

import { type MaybeVNodes, onInsert } from 'lib/view';

import type TournamentController from '../ctrl';
import { controls, standing } from './arena';
import { teamStanding } from './battle';
import header from './header';
import teamInfo from './teamInfo';

export const name = 'created';

export function main(ctrl: TournamentController): MaybeVNodes {
  return [
    header(ctrl),
    teamStanding(ctrl, 'created'),
    controls(ctrl),
    standing(ctrl, 'created'),
    h('blockquote.pull-quote', [h('p', ctrl.data.quote.text), h('footer', ctrl.data.quote.author)]),
    ctrl.opts.$faq ? h('div', { hook: onInsert(el => $(el).replaceWith(ctrl.opts.$faq)) }) : null,
  ];
}

export function table(ctrl: TournamentController): VNode | undefined {
  return ctrl.teamInfo.requested ? teamInfo(ctrl) : undefined;
}
